import { createDomain, sample } from 'effector'
import { driverModel } from '~/entities/Driver'
import {
  AxiosErrorType,
  DriverCreateIndividualEntrepreneurEvent,
} from '~/shared/api'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { notificationModalOpen } from '~/shared/lib/notificationModal'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { formModel } from './Content/Form'

const domain = createDomain(
  'features.DriverOccupations.FillIndividualEntrepreneurDrawer',
)

export const formSubmit = domain.createEvent<{
  formValues: formModel.FormValues
  fn: () => void
}>()

export const formSubmitFx = domain.createEffect<
  {
    formValues: formModel.FormValues
    fn: () => void
  },
  void,
  AxiosErrorType
>({
  async handler({ formValues, fn }) {
    const event = new DriverCreateIndividualEntrepreneurEvent(formValues)
    await event.create()
    await driverModel.getDriverSilentFx()
    fn()
  },
})

sample({
  clock: formSubmit,
  target: formSubmitFx,
})

sample({
  clock: formSubmitFx.doneData,
  fn() {
    return {
      title: 'Ваши данные по ИП отправлены на проверку!',
      description: 'это может занять до 5 минут',
      variant: 'success' as const,
    }
  },
  target: notificationModalOpen,
})

sample({
  clock: formSubmitFx.failData,
  fn(e) {
    return {
      message: mapMessageErrors(e),
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})
